// Charge la base commune
import './common.js'
import { dtectMap } from './js/libs/utils.js'
import { agenciesMap } from './js/components/agenciesMap.js'

import './scss/pages/contact.scss'

// Contact Form
async function getCForm ($f) {
  import(/* webpackChunkName: "contactForm" */ './js/components/contactForm.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

$(document).ready(function () {
  // formulaire de contact
  const $c = $('form[name="cForm"]')
  $c.waypoint(
    function () {
      $c.load()
      getCForm($c)
      this.destroy()
    },
    {
      offset: '100%'
    }
  )

  console.log('dtectMap')
  // à exécuter une fois la GMap API correctement chargée
  dtectMap(function () {
    // gestion de la carte des agences
    const $c5 = $('#map-agencies').length ? $('#map-agencies') : $('#map-detail')
    console.log($c5)
    if ($c5.length) {
      $c5.waypoint(
        function () {
          agenciesMap.init($c5)
          this.destroy()
        },
        {
          offset: '100%'
        }
      )
    }
  })
})
